#### Downloading hirer list CSVs

The [Developer Dashboard hirers page] now supports generating a CSV of all the SEEK hirers you have an [active relationship] with.
Previously, you would’ve had to contact SEEK for a hirer spreadsheet or use the Developer Dashboard web interface.

The CSV can be generated by clicking the “Download CSV” button.
This will respect the current hirer search filter; ensure you clear the filters if you want a list of all hirers.

[active relationship]: /auth/hirer-relationships
[Developer Dashboard hirers page]: /manage/hirers
